import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LogincacheService } from '../../graphqlserver/logincache.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private router:Router, private usercache:LogincacheService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const x=this.usercache.getUserLoggedIn();
      let token = localStorage.getItem('token');
      if(token == null)token="";
  
      if(token.length>20 && x){
        //localStorage.setItem('menu','true');//solo cambiar en el servicio esta bien
        return true;
      }else{
        //localStorage.removeItem('menu');//solo cambiar en el servicio
        //this.router.navigate(['principal/login']);
        this.router.navigateByUrl('/principal/login');
        return false;
      }
  }
}